import fieldTypes from '../../../../../../enums/FieldTypes';
import stripCharacters from '../../../../../utils/strip-characters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import houseNameOrNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import PredictionsByField from '../../PredictionsByField';
import * as required from '../../required-validators';
import {fourDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';
import validateAutocompleteField from '../../validateAutocompleteField';

const formatBGPostcode = (value) => {
  if (!value) return;
  return value.replace(/\s/g, '');
};

const provinces = PredictionsByField.county('BG');

const FieldDefinitionBG = [
  addressee,
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    maxLength: 4,
    transform: formatBGPostcode,
    validate: [required.postCode, max.lengthAddress(4), fourDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
  },
  companyName,
  houseNameOrNumber,
  streetName,
  addressLine2,
  townCity,
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: provinces,
    validate: [required.county, validateAutocompleteField(provinces, 'county')],
  },
];

export default FieldDefinitionBG;
